import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";

const fetch = (authHeader: string) => () =>
  axios.get(`${env.verifyServiceUrl}individual/mandate/status_report/`, {
    headers: {
      Authorization: authHeader,
    },
  });
  
export const useStatusReport = () => {
  const { authHeader, isLoggedIn } = useAuth();
  const navigate = useNavigate();
  return useQuery(["statusReport"], fetch(authHeader), {
    enabled: isLoggedIn,
    retry: false,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
    }
  });
};
